import React, {useState, useCallback} from 'react';
import useCustomTable from "./useCustomTable";
import {usePrevious} from "../utils";
import {useLoader} from "../loader/Loader";


function useAsyncTable({callback, ...props}) {
  const [data, setData] = useState([]);
  const [pageCount, setPageCount] = React.useState(0);
  const [totalSize, setTotalSize] = React.useState(0);
  const { tableProps, paginationProps, tableSearchProps, tablePageLengthProps, sortByProps, tableFilterProps } = useCustomTable(props)
  const { globalFilter } = tableSearchProps
  const { filters } = tableFilterProps
  const { pageIndex, pageSize } = paginationProps
  const { sortBy } = sortByProps
  const prevFilters = usePrevious(filters);

  const {onSuccess, onError, loaderProps, setLoading} = useLoader();

  const fetchData = useCallback(() => {
    setLoading()
    callback({ page: pageIndex, perPage: pageSize, sortBy, globalFilter, filters }, true)
      .then((response)=>{
        setPageCount(Math.ceil(response.data.length/pageSize));
        setTotalSize(response.data.length);
        setData(response.data.data);
        onSuccess()
      })
      .catch(error => {
        onError()
      })
  }, [pageIndex, pageSize, sortBy, globalFilter, filters])

  const asyncTableProps = {
    ...tableProps,
    async: true,
    data,
    pageCount,
    totalSize,
    loaderProps
  }


  React.useEffect(() => {
    if (pageIndex && pageSize && !shouldDebounceSearch(globalFilter) && !shouldDebounceFilters(filters, prevFilters)) {
      fetchData()
    }
  }, [pageIndex, pageSize, sortBy, globalFilter, filters]);

  return {tableProps: asyncTableProps, paginationProps, tableSearchProps, tablePageLengthProps, sortByProps, tableFilterProps}
}

const shouldDebounceSearch = function(newVal) {
  return newVal?.length < 3
}

const shouldDebounce = function(newFilter) {
  if (Array.isArray(newFilter)) {
    return false
  } else {
    return shouldDebounceSearch(newFilter)
  }
}

const changedFilterId = function(filters1 = [], filters2 = []) {
  let filter_id
  filters1.forEach((filter1) => {
    if (filter1.value != filters2.find(filter2 => filter2.id == filter1.id)?.value) {
      filter_id = filter1.id
    }
  })
  return filter_id
}

const shouldDebounceFilters = function(newFilters, oldFilters) {
  let filter_id = changedFilterId(newFilters, oldFilters)
  if (!filter_id) {
    filter_id = changedFilterId(oldFilters, newFilters)
  }
  if (filter_id) {
    return shouldDebounce(newFilters.find(el => el.id == filter_id)?.value)
  } else {
    return false
  }
}

export default useAsyncTable
